export enum OrderRejectReason {
  EMPTY_KM = 'empty-km',
  WAITING_TIME = 'waiting-time',
  VEHICLE_UNAVAILABLE = 'vehicle-unavailable',
  WORKING_TIME_PROBLEM = 'working-time-problem',
  OTHER = 'other',
}
